import { PlanModelInfo, planTypes } from '@/common/constants';
import { enableCAICSwitchToStandalone, enableCAICPlanRebranding } from './utils.js';
import {
  billingCycleDependBasePlanTypeList,
  dependMeetingPlanTypeList,
  licenseDependBasePlanTypeList,
  ZOOM_CAIC_MAX_LICENSE,
  ZOOM_CAIC_MIN_LICENSE
} from '@/common/constants';

import { planUnitMap } from '@/common/product-unit';
import { defaultMapper } from '@/common/service/default-mapper';

const aiCompanionCategory = {
  [planTypes.ZOOM_CUSTOM_AI_COMPANION]: {
    typeNameKey: enableCAICPlanRebranding
      ? 'billing.zoom_custom_ai_companion.rebranding_title'
      : 'billing.zoom_custom_ai_companion.title',
    planNameKey: enableCAICPlanRebranding
      ? 'billing.zoom_custom_ai_companion.rebranding_title'
      : 'billing.zoom_custom_ai_companion.title',
  },
};

export default (planMapJSON = {}) => {
  const result = Object.keys(aiCompanionCategory).reduce((pre, key) => {
    return [
      ...defaultMapper(planMapJSON[key], planTypes.ZOOM_CUSTOM_AI_COMPANION).map((item) => ({
        ...item,
        ...aiCompanionCategory[key],
        billingCycleDependBasePlanTypeList: enableCAICSwitchToStandalone ? [] : billingCycleDependBasePlanTypeList,
        dependBasePlanTypeList: enableCAICSwitchToStandalone ? [] : dependMeetingPlanTypeList,
        licenseDependBasePlanTypeList: enableCAICSwitchToStandalone ? [] : licenseDependBasePlanTypeList,
        unit: planUnitMap.user,
        min: ZOOM_CAIC_MIN_LICENSE,
        max: ZOOM_CAIC_MAX_LICENSE,
        planModel: PlanModelInfo.license
      })),
      ...pre,
    ];
  }, []);
  return result;
};
